
import React from "react";
import { Label } from "@/components/ui/label";
import NumericInput from "@/components/ui/NumericInput";
import { InfoIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface CashReservesInputProps {
  cashReserves: number;
  onChange: (value: number) => void;
}

const CashReservesInput: React.FC<CashReservesInputProps> = ({ cashReserves, onChange }) => {
  return (
    <div className="space-y-1">
      <div className="flex items-center">
        <Label htmlFor="cashReserves">Cash Reserves (months)</Label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <InfoIcon className="h-4 w-4 text-gray-400 ml-2" />
            </TooltipTrigger>
            <TooltipContent className="w-80 p-3">
              <p>Cash reserves are funds available after closing, expressed as months of 
              mortgage payments. Higher reserves improve approval chances.</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <NumericInput
        id="cashReserves"
        value={cashReserves}
        onChange={onChange}
        min={0}
        step={1}
        decimalPlaces={0}
        inputClassName="w-full sm:w-48"
      />
    </div>
  );
};

export default CashReservesInput;
